import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

// @ts-expect-error
import { testkit as inputTestkit } from '../Input/Input.uni.driver';
import { tickerDriverFactory } from '../Input/Ticker/Ticker.uni.driver';
import { dataHooks } from './constants';

export const numberInputDriverFactory = (base: UniDriver, body: UniDriver) => {
  const getTickerDriver = () =>
    tickerDriverFactory(base.$(`[data-hook="${dataHooks.numberInputTicker}"]`));
  return {
    ...inputTestkit(base, body),
    /** Click on ticker up */
    clickOnIncrement: (): Promise<void> => getTickerDriver().clickUp(),
    /** Click on ticker down */
    clickOnDecrement: (): Promise<void> => getTickerDriver().clickDown(),
    /** Check if ticker down is disabled */
    isDownDisabled: () => getTickerDriver().isDownDisabled(),
    /** Check if ticker up is disabled */
    isUpDisabled: () => getTickerDriver().isUpDisabled(),
  };
};

export type NumberInputUniDriver = ReturnType<typeof numberInputDriverFactory>;
